import { Inject, Injectable } from '@angular/core';
import { CheckoutFacade } from '@checkout/data-access';
import {
  CheckoutDirectDebitPaymentDetails,
  CmsDirectDebitPage,
  DirectDebitFormValue,
} from '@checkout/util-models';
import { BasketFacade, QuoteDetails } from '@domgen/dgx-fe-basket';
import { CmsContainer } from '@domgen/dgx-fe-cms';
import { DocumentSendMethod, filterNullUndefined } from '@domgen/dgx-fe-common';
import { FORM_CONFIG, FormConfig } from '@domgen/dgx-fe-forms/shared';

import { Observable, combineLatest } from 'rxjs';
import { formatDirectDebitFormValueToPaymentDetails } from '../../utils/direct-debit-form/direct-debit-form.utils';
export interface ViewModel {
  basketItemsFirstQuotesHasFirstMonthFreePromotionalOffer: boolean;
  hasMonthsFreePromotionalOffer: boolean;
  cmsData: CmsDirectDebitPage;
  monthlyPayment: number;
  requestedBasketItemFirstQuote?: QuoteDetails;
}

@Injectable()
export class DirectDebitComponentService {
  private basketItemsFirstQuotesHasFirstMonthFreePromotionalOffer$: Observable<boolean> =
    this.formConfig.clpEnabled
      ? this.basketFacade
          .basketItemsFirstCLPQuotesHasFirstMonthFreePromotionalOffer$
      : this.basketFacade
          .basketItemsFirstQuotesHasFirstMonthFreePromotionalOffer$;

  readonly vm$: Observable<ViewModel> = combineLatest({
    basketItemsFirstQuotesHasFirstMonthFreePromotionalOffer:
      this.basketItemsFirstQuotesHasFirstMonthFreePromotionalOffer$,
    hasMonthsFreePromotionalOffer:
      this.checkoutFacade.hasMonthsFreePromotionalOffer$,
    requestedBasketItemFirstQuote:
      this.basketFacade.requestedBasketItemFirstQuote$,
    cmsData: this.cmsContainer.content$,
    monthlyPayment:
      this.basketFacade.selectedQuotesTotalSubsequentPayment$.pipe(
        filterNullUndefined()
      ),
  });

  constructor(
    @Inject(FORM_CONFIG) private readonly formConfig: FormConfig,
    private readonly basketFacade: BasketFacade,
    private readonly checkoutFacade: CheckoutFacade,
    private readonly cmsContainer: CmsContainer<CmsDirectDebitPage>
  ) {}

  onFormSubmit(formValue: DirectDebitFormValue): void {
    const paymentDetails: CheckoutDirectDebitPaymentDetails | undefined =
      formatDirectDebitFormValueToPaymentDetails(formValue);

    if (!paymentDetails) {
      return;
    }

    this.checkoutFacade.updateDocumentSendMethod(
      formValue.paperlessPreference
        ? DocumentSendMethod.Both
        : DocumentSendMethod.Email
    );
    this.checkoutFacade.checkoutRequest(paymentDetails);
  }
}
